import { useEffect, useMemo, useRef, useState } from "react";
import { CharacterPartType } from "../../dto/CharacterPartDTO";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import PiScrollArea from "../../components/PiScrollArea";
import SortIcon from "@mui/icons-material/Sort";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AssetSortOptions } from "../../models/AssetSortOptions";
import { selectSortBy, setAssetsSortBy } from "../../app/slices/AssetsSlice";
import { useDispatch, useSelector } from "react-redux";
import { setSortBy } from "../../app/slices/ProjectsSlice";
export default function FileExplorerSortDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);
  const [width, setWidth] = useState<number>(1000);
  const currentSortOptionSi = useSelector(selectSortBy);
  const currentSortOption = useMemo(
    () =>
      AssetSortOptions.find((option) => option.value === currentSortOptionSi),
    [currentSortOptionSi]
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (ref.current) {
      var w = ref.current?.offsetWidth.toString() + "px";
      setWidth(ref.current?.offsetWidth);
    }
  }, [ref.current?.offsetWidth]);

  const onChange = (option: string) => {
    dispatch(setAssetsSortBy(option));
  };

  const map = AssetSortOptions.map((type) => {
    return (
      <DropdownMenu.Item
        className={
          "h-[32px] rounded-[6px] bg-creator-surface text-creator-text text-[12px] cursor-pointer hover:bg-creator-childActive flex mx-[6px] px-[10px] border-none" +
          " outline-none font-medium"
        }
        onClick={() => {
          onChange(type.value);
        }}
        key={type.value}
      >
        <div className={"my-auto truncate"}>{type.name}</div>
      </DropdownMenu.Item>
    );
  });

  return (
    // A quiet control in the search row, matching the multi-select toggle and
    // the view switcher beside it — the blue pill outshouted the results.
    <div ref={ref} className="h-[30px]">
      <DropdownMenu.Root onOpenChange={setIsOpen} modal={false}>
        <DropdownMenu.Trigger className="focus:outline-none">
          <div className="h-[30px] rounded-[6px] border border-creator-border bg-creator-surface flex items-center gap-[7px] pl-[10px] pr-[9px] hover:bg-creator-childActive transition-colors">
            <span className="flex text-[13px] text-creator-text-sub">
              <SortIcon fontSize="inherit" />
            </span>
            <span className="text-[12px] leading-[18px] font-medium text-creator-text whitespace-nowrap">
              {currentSortOption ? currentSortOption.name : "Choose Sort"}
            </span>
            <span className="flex text-[11px] text-creator-text-sub">
              <ExpandMoreIcon fontSize="inherit" />
            </span>
          </div>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content
          className={
            "py-[6px] z-40 bg-creator-surface shadow-lg border border-creator-border rounded-[8px]"
          }
          style={{ minWidth: width + "px" }}
        >
          <PiScrollArea variant={"piCreatorBlue"} maxHeight={400}>
            {map}
          </PiScrollArea>
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </div>
  );
}
